import React from "react";
import { useEffect } from "react";

function Health() {
  useEffect(() => {
    document.title = "Health and Wellbeing";
  });

  return (
    <div class="content">
      <div class="w-container">
        <div class="page-head">
          <div class="page-title">
            <h1 class="h1">Health &amp; Wellbeing</h1>
          </div>
        <div class="sub-hrule"></div>
        </div>
        <div class="people-section">
          <div id="rhanav" class="from-navbar-ref"></div>
        <div class="people-section">
          <div id="carenav" class="from-navbar-ref"></div>
          <div id="care" class="page-nav-ref"></div>
          <div class="sub-head">
            <h3 class="h3">Head Caregivers</h3>
            <div class="sub-hrule"></div>
            <p class="paragraph-center sub">
              Head Caregivers are students who promote safety and accountability
              at parties and similar events. They organize, promote, and present
              caregiving trainings in conjunction with EMS and Wellbeing.
            </p>
          </div>
          <div class="resa-grid">
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/misc/Nathan Chen.jpg"
                  height="200"
                  alt="Nathan Chen"
                />
              </div>
              <div class="name">
                <h4 class="h4">Nathan Chen</h4>
              </div>
              <div>
                <a class="position" href="mailto: nc76@rice.edu">
                  <u>nc76@rice.edu</u>
                </a>
              </div>
            </div>
            <div class="person-card">
              <div class="prof-pic">
                <img
                  src="/images2026-27/head-caregivers/Eesha Surapaneni.jpg"
                  height="200"
                  alt="Eesha Surapaneni"
                />
              </div>
              <div class="name">
                <h4 class="h4">Eesha Surapaneni</h4>
              </div>
              <div>
                <a class="position" href="mailto: es157@rice.edu">
                  <u>es157@rice.edu</u>
                </a>
              </div>
            </div>
          </div>
        </div>
          <div id="rha" class="page-nav-ref"></div>
          <div class="sub-head">
            <h3 class="h3">Rice Health Advisors (RHA)</h3>
            <div class="sub-hrule"></div>
            <p class="paragraph-center sub">
              Rice Health Advisors (RHAs) are students who are trained to give
              mental and psychological support to peers, along with aid for
              minor physical problems. RHAs are available as resources to talk
              to you about any wellness concerns and provide kits that contain
              minor first aid tools and medication.
            </p>
          </div>
          <div class="resa-grid" style={{marginBottom: "30px"}}>
            <div class="rha-card-wrap">
              <h4 class="h4">Aislinn Burns</h4>
              <strong>Head RHA</strong>
              <a class="position" href="mailto: akb15@rice.edu">
                <u>akb15@rice.edu</u>
              </a>
            </div>
            <div class="rha-card-wrap">
              <h4 class="h4">Eon Lim</h4>
              <strong>Head RHA</strong>
              <a class="position" href="mailto: ekl3@rice.edu">
                <u>ekl3@rice.edu</u>
              </a>
            </div>
          </div>
          <div class="rha-content">
            <div class="rha-card-wrap">
              <h4 class="h4">Isabelle Shen</h4>
              <a class="position" href="mailto: is51@rice.edu">
                <u>is51@rice.edu</u>
              </a>
            </div>
            <div class="rha-card-wrap">
              <h4 class="h4">Matthew Ochoa</h4>
              <a class="position" href="mailto: mo57@rice.edu">
                <u>mo57@rice.edu</u>
              </a>
            </div>
            <div class="rha-card-wrap">
              <h4 class="h4">Jihra Hill</h4>
              <a class="position" href="mailto: jgh10@rice.edu">
                <u>jgh10@rice.edu</u>
              </a>
            </div>
            <div class="rha-card-wrap">
              <h4 class="h4">Diana Ho</h4>
              <a class="position" href="mailto: dh87@rice.edu">
                <u>dh87@rice.edu</u>
              </a>
            </div>
            <div class="rha-card-wrap">
              <h4 class="h4">Sara Edelstein</h4>
              <a class="position" href="mailto: se52@rice.edu">
                <u>se52@rice.edu</u>
              </a>
            </div>
            <div class="rha-card-wrap">
              <h4 class="h4">Akhil Rokkam</h4>
              <a class="position" href="mailto: avr10@rice.edu">
                <u>avr10@rice.edu</u>
              </a>
            </div>
            <div class="rha-card-wrap">
              <h4 class="h4">Akul Mittal</h4>
              <a class="position" href="mailto: am557@rice.edu">
                <u>am557@rice.edu</u>
              </a>
            </div>
            <div class="rha-card-wrap">
              <h4 class="h4">Xavi Gallart</h4>
              <a class="position" href="mailto: xg35@rice.edu">
                <u>xg35@rice.edu</u>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Health;
